export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8970.4ad4a30a.jpg";